import { get } from 'libs/GrebbCommerceAPI/util';

export default async basketId => {
    return await get(`/basket/${basketId}/receipt`);
};
